import React from 'react';
import { orderSteps } from '../../data/home';
export function OrderSteps() {
  return <section className="bg-ink py-20 md:py-32" aria-labelledby="order-heading" data-id="element-190" data-mp="2gaows56cis1d">
      <div className="mx-auto max-w-[1320px] px-5 md:px-8" data-id="element-191" data-mp="2lab98ceco494">
        <h2 id="order-heading" className="text-center font-display text-5xl font-bold uppercase leading-[0.9] text-chalk md:text-7xl" data-id="element-192" data-mp="2l8qgmsblivdw">
          How to Order
        </h2>
        <ol className="mt-12 grid gap-4 rounded-[32px] bg-flame p-4 sm:grid-cols-2 md:mt-14 md:p-6 lg:grid-cols-4" data-id="element-193" data-mp="2uzl0xr5a7kwp">
          {orderSteps.map((step, index) => <li key={step.title} className="flex flex-col items-center rounded-[22px] bg-ink p-7 text-center sm:min-h-[280px] sm:items-start sm:text-left" data-id="element-194" data-mp="340j8gjexiak1" data-mpi={index}>
              <span className="font-display text-7xl font-bold leading-none text-flame" data-id="element-195" data-mp="19nbcgof7vswt">
                {String(index + 1).padStart(2, '0')}
              </span>
              <div className="mt-6 sm:mt-auto sm:pt-10" data-id="element-196" data-mp="1enpik0x9css7">
                <h3 className="font-display text-3xl font-bold uppercase leading-none text-chalk" data-id="element-197" data-mp="nz0p5cx51422">{step.title}</h3>
                <p className="mt-3 leading-relaxed text-muted" data-id="element-198" data-mp="j5z2ujulq28g">{step.text}</p>
              </div>
            </li>)}
        </ol>
      </div>
    </section>;
}